import { Link } from "react-router-dom";
import { UNDERLINE_CLASS } from "../utils";

export const Footer = ({
  policy,
  contact,
}: {
  policy?: { label: string; href: string }[];
  contact?: { label: string; href: string }[];
}) => {
  return contact || policy ? (
    <div className="pb-8 p-4 lg:p-5 mt-4 flex justify-between bg-textMain text-main">
      <div className="lg:basis-9/12  xl:basis-6/12 2xl:basis-5/12 flex flex-wrap flex-col justify-between pt-1">
        {policy?.map((policyItem) => (
          <Link
            key={policyItem.href + policyItem.label}
            className={UNDERLINE_CLASS}
            to={policyItem.href}
          >
            {policyItem.label}
          </Link>
        ))}
      </div>
      <div className="lg:basis-9/12  xl:basis-6/12 2xl:basis-5/12 flex flex-wrap flex-col justify-between pt-1 text-right ">
        {contact?.map((contactItem) => (
          <Link
            key={contactItem.href + contactItem.label}
            className={UNDERLINE_CLASS}
            to={contactItem.href}
          >
            {contactItem.label}
          </Link>
        ))}
      </div>
    </div>
  ) : null;
};
